import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=1951c59d&scoped=true"
import script from "./PointList.vue?vue&type=script&lang=js"
export * from "./PointList.vue?vue&type=script&lang=js"
import style0 from "./PointList.vue?vue&type=style&index=0&id=1951c59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951c59d",
  null
  
)

export default component.exports